/**
 * This tracks login/signup impressions and clicks
 * using LinkedIn Tracking
 */
import logEvent from "./amplitude/log-event"
;(function (win) {
  // Dependencies.
  let ss = win.slideshare_object,
    utils = ss.utils

  let channels = {
    facebook: "FACEBOOK",
    scribd: "SCRIBD",
    linkedin: "LINKEDIN",
    linkedinUno: "LINKEDIN_REG",
    slideshare: "SLIDESHARE",
  }

  /**
   * Creates a new LoginTracker instance.
   *
   * @constructor
   */
  function LoginTracker() {}

  /**
   * Fires a SlideShareLoginClickEvent
   *
   * @param {String} channel - Channel from where the click was triggered
   */
  LoginTracker.prototype._trackClick = function (channel) {
    const source = getUrlVar("login_source")
    const path = win.document.location.pathname

    this.logEventToAmplitude("login_attempt", channel, source, path)
  }
  /**
   * Fires a SlideShareLoginClickEvent
   *
   * @param {String} channel - Track Login Errors
   */
  LoginTracker.prototype._trackLoginError = function () {
    const source = getUrlVar("login_source")
    const path = win.document.location.pathname

    this.logEventToAmplitude("login_failure", channels.slideshare, source, path)
  }

  LoginTracker.prototype.trackDisabledFacebookLogin = function () {
    const source = getUrlVar("login_source")
    const path = win.document.location.pathname
    this.logEventToAmplitude("facebook_disabled_login_attempt", "facebook", source, path)
  }

  /**
   * Fires a SlideShareLoginClickEvent for SlideShare CTA
   */
  LoginTracker.prototype.trackSlideShareClick = function () {
    this._trackClick(channels.slideshare)
  }

  /**
   * Fires a SlideShareLoginClickEvent for Facebook CTA
   */
  LoginTracker.prototype.trackFacebookClick = function () {
    this._trackClick(channels.facebook)
  }

  /**
   * Fires a SlideShareLoginClickEvent for Scribd CTA
   */
  LoginTracker.prototype.trackScribdClick = function () {
    this._trackClick(channels.scribd)
  }

  /**
   * Fires a SlideShareLoginClickEvent for LinkedIn CTA
   */
  LoginTracker.prototype.trackLinkedinClick = function () {
    this._trackClick(channels.linkedin)
  }

  LoginTracker.prototype.logEventToAmplitude = function (name, channel, source, path) {
    const eventOptions = {
      source: source,
      channel: channel,
      path: path,
    }

    logEvent(name, eventOptions)
  }

  /**
   * Export Login Tracker
   */
  utils.exports("tracking.LoginTracker", LoginTracker)
})(window)
